import React, { useState } from "react";
import "./Contact.scss";
import illustration from '../../assets/images/illu yamuna 1.png';
import MailIcon from '../../assets/icons/mailicon.png';
import WhatsappIcon from '../../assets/icons/whtsappiconn.png';
import InstaIcon from '../../assets/icons/instaicon.png';
import FBIcon from '../../assets/icons/fbicon.png';

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    message: "",
  });

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    const fullName = `${formData.firstName} ${formData.lastName}`.trim();
    
    const finalFormData = new FormData();
    finalFormData.append("name", fullName);
    finalFormData.append("email", formData.email);
    finalFormData.append("contactNumber", formData.contactNumber);
    finalFormData.append("message", formData.message);
    finalFormData.append("form_type", "contact_us");


    fetch('form-handler.php', {
      method: 'POST',
      body: finalFormData,
    })
      .then((response) => response.text())
      .then((data) => {
        console.log(data);
        alert("Message sent successfully");
        setFormData({ firstName: "", lastName: "", email: "", contactNumber: "", message: "" });
      })
      .catch((error) => {
        console.error('Error:', error);
        alert("Something went wrong. Please try again.");
      });
  };

  return (
    <div className="contact-us">
      <h2>CONTACT US</h2>
      <div className="contact-info">
        <div className="info-box">
          <img src={MailIcon} alt="Mail" />
          <span>contactus@yamunafashion.in</span>
        </div>
        <div className="info-box">
          <img src={WhatsappIcon} alt="WhatsApp" />
          <span>+91 7353381765</span>
        </div>
        <div className="info-box">
          <img src={InstaIcon} alt="Instagram" />
          <span>Instagram</span>
        </div>
        <div className="info-box">
          <img src={FBIcon} alt="Facebook" />
          <span>Facebook</span>
        </div>
      </div>
      <div className="contact-content">
        <form className="contact-form" onSubmit={handleSubmit}>
          <input type="hidden" name="form_type" value="contact_us" />
          <div className="form-row">
            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name" required />
            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name" required />
          </div>
          <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address" required />
          <input type="tel" name="contactNumber" value={formData.contactNumber} onChange={handleChange} placeholder="Contact Number" required />
          <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your Query" rows={4} required></textarea>
          <button type="submit">Send</button>
        </form>
        <div className="illustration">
          <img src={illustration} alt="Illustration" />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
